import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckoutView } from "@/components/Checkout/CheckoutView";
import { LoginDialogProvider } from "@/components/common/LoginDialogProvider";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { cn } from "@/lib/utils";
import { Typography } from "@bookips/sds";
import { FormProvider, useForm } from "react-hook-form";
const CheckoutNextPage = (param)=>{
    let { orderInfo  } = param;
    var _user_address, _user_address1, _user_address2, _user_address3, _user_address4, _user_address5, _user_address6;
    const { user  } = useAuthStore();
    const method = useForm({
        mode: "onTouched",
        defaultValues: {
            name: (user === null || user === void 0 ? void 0 : user.displayName) || "",
            phone: (user === null || user === void 0 ? void 0 : user.phoneNumber) || "",
            deliveryName: (user === null || user === void 0 ? void 0 : (_user_address = user.address) === null || _user_address === void 0 ? void 0 : _user_address.addressName) || "",
            recipientName: (user === null || user === void 0 ? void 0 : (_user_address1 = user.address) === null || _user_address1 === void 0 ? void 0 : _user_address1.name) || "",
            recipientPhone: (user === null || user === void 0 ? void 0 : (_user_address2 = user.address) === null || _user_address2 === void 0 ? void 0 : _user_address2.phone) || "",
            address1: (user === null || user === void 0 ? void 0 : (_user_address3 = user.address) === null || _user_address3 === void 0 ? void 0 : _user_address3.address1) || "",
            address2: (user === null || user === void 0 ? void 0 : (_user_address4 = user.address) === null || _user_address4 === void 0 ? void 0 : _user_address4.address2) || "",
            postalCode: (user === null || user === void 0 ? void 0 : (_user_address5 = user.address) === null || _user_address5 === void 0 ? void 0 : _user_address5.postalCode) || "",
            message: (user === null || user === void 0 ? void 0 : (_user_address6 = user.address) === null || _user_address6 === void 0 ? void 0 : _user_address6.message) || "",
            buyerName: (orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.buyerName) || (user === null || user === void 0 ? void 0 : user.displayName) || "",
            buyerPhone: (orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.buyerPhone) || (user === null || user === void 0 ? void 0 : user.phoneNumber) || ""
        }
    });
    return /*#__PURE__*/ _jsx(LoginDialogProvider, {
        children: /*#__PURE__*/ _jsxs(Container, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "mt-10 mb-5 flex w-full max-w-[1200px] max-lg:px-8 max-sm:px-5",
                    children: /*#__PURE__*/ _jsx(Typography, {
                        variant: "h4",
                        children: "주문/결제"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "flex w-full justify-center bg-gray-50",
                    children: /*#__PURE__*/ _jsx(FormProvider, {
                        ...method,
                        children: /*#__PURE__*/ _jsx(CheckoutView, {})
                    })
                })
            ]
        })
    });
};
export var __N_SSP = true;
export const Container = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: cn("flex h-full w-full flex-col items-center", className),
        children: children
    });
};
export default CheckoutNextPage;
